// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"k_NQHg","wrapper--mobile":"f1IZeY","message":"_3yIR_6"};